import React from "react";

const LittlePain = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_939_531)">
                <ellipse cx="24.0002" cy="24" rx="22.9787" ry="23" fill="white" />
                <path
                    d="M24.0477 47.9855C12.4618 48.4228 0.0126005 39.0276 1.1034e-05 24.0809C-0.0125784 10.3165 10.7496 0.0340887 23.9577 -0.000101909C36.5724 -0.032493 47.9011 9.62905 48.0072 23.9945C48.0517 27.1558 47.4625 30.294 46.2744 33.2237C45.0863 36.1534 43.3234 38.815 41.0899 41.0515C38.8564 43.288 36.1975 45.0539 33.2704 46.2448C30.3433 47.4358 27.2073 48.0277 24.0477 47.9855V47.9855ZM24.0567 1.94696C11.8917 1.97755 2.01073 11.6067 1.93519 23.7948C1.86865 36.0314 10.9942 46.0205 23.7941 46.1086C36.4861 46.1932 45.9156 36.7278 46.0253 24.1547C46.153 10.7951 35.4627 2.01894 24.0567 1.94696Z"
                    fill="black"
                />
                <path
                    d="M12.7837 31.2448C13.4581 30.3451 13.9024 30.7842 14.4275 31.0469C16.1055 31.8855 17.7493 32.877 19.5244 33.4258C23.5243 34.6621 27.4666 34.2284 31.229 32.3785C32.3225 31.8387 33.3747 31.216 34.5185 30.5916C35.362 31.3528 34.9897 32.06 34.4645 32.7168C32.4646 35.2163 30.0133 37.0248 26.8317 37.7752C21.7564 38.9683 15.8987 36.5876 13.1632 32.1518C13.0138 31.8596 12.8869 31.5564 12.7837 31.2448V31.2448Z"
                    fill="black"
                />
                <path
                    d="M18.6917 19.7621C18.6917 21.9395 16.9939 23.6203 14.7746 23.6455C13.7329 23.6638 12.7262 23.2693 11.9742 22.5478C11.2222 21.8264 10.7858 20.8366 10.7604 19.7945C10.683 17.7611 12.8052 15.6557 14.8969 15.7043C16.9885 15.7528 18.6917 17.5523 18.6917 19.7621Z"
                    fill="black"
                />
                <path
                    d="M33.2453 23.6419C31.5475 23.9136 29.357 22.2329 29.2113 19.8629C29.08 17.7035 31.0511 15.7061 33.168 15.6935C35.2398 15.6827 37.3045 17.7017 37.2703 19.7909C37.2452 21.4807 35.2614 23.901 33.2453 23.6419Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_939_531">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LittlePain;
